const initialState = {
};

export const tablePreviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_TABLE_PREVIEW':
      return {
        ...state,
        [action.payload.tableName]: action.payload.data
      };

    case 'ADD_ROW':
      console.log('ADD action.payload.row', action.payload.row)

      return {
        ...state,
        [action.payload.tableName]: Array.isArray(state[action.payload.tableName])
          ? [...state[action.payload.tableName], action.payload.row]
          : [action.payload.row]
      };

    case 'UPDATE_ROW':
      console.log('UPDATE action.payload.row', action.payload.row)

      if (!Array.isArray(state[action.payload.tableName]?.rows))
        return state;

      // find the position of the primary key in the columns array
      const primariyKeyPosition = state[action.payload.tableName].columns.findIndex(column => column === action.payload.primaryKey);

      // find the row in the rows array where the value at the primariyKeyPosition is equal to the primary key
      const rowIndex = state[action.payload.tableName].rows.findIndex(row => row[primariyKeyPosition] === action.payload.row[action.payload.primaryKey]);

      // Create new rows array with updated row at rowIndex
      const updatedRows = [
        ...state[action.payload.tableName].rows.slice(0, rowIndex),
        Object.values(action.payload.row),
        ...state[action.payload.tableName].rows.slice(rowIndex + 1)
      ];

      return {
        ...state,
        [action.payload.tableName]: {
          ...state[action.payload.tableName],
          rows: updatedRows
        }
      };

    default:
      return state;
  }
};
